import { render } from "./CompanyArchive.vue?vue&type=template&id=26921a4e"
import script from "./CompanyArchive.vue?vue&type=script&lang=js"
export * from "./CompanyArchive.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__